import { backgroundManager } from '@/threejs/managers/backgroundManager';
import { edgesManager } from '@/threejs/managers/edgesManager';
import { gridManager } from '@/threejs/managers/gridManager';
import { lightingManager } from '@/threejs/managers/lightingManager';
import { materialManager } from '@/threejs/managers/materialManager';
import { projectorManager } from '@/threejs/managers/projectorManager';

export const useViewportSettings = () => {
  const handleViewportSettingChange = (key, value) => {
    // Initialize managers if not already done

    if (!backgroundManager.isManagerInitialized()) {
      backgroundManager.initialize();
    }

    // Route settings to appropriate managers
    if (key.startsWith('grid.')) {
      gridManager.handleGridSetting(key, value);
    } else if (key.startsWith('brightness.')) {
      lightingManager.handleLightingSetting(key, value);
    } else if (key.startsWith('render.')) {
      // Route render settings to appropriate managers
      if (key === 'render.photometricMaxValue') {
        // Photometric max value is handled by a watcher in scene.js
        // that updates frustumOverlay.setLuxMax() directly
      } else if (key.includes('background') || key.includes('gradient')) {
        backgroundManager.handleBackgroundSetting(key, value);
      } else if (key.includes('objectEdge') || key.includes('ObjectEdge') || key.includes('globalDoubleSided')) {
        edgesManager.handleEdgesSetting(key, value);
      } else if (key.includes('showProjector')) {
        // Route projector visibility settings to projectorManager
        projectorManager.handleProjectorSetting(key, value);
      } else if (key.includes('globalMaterialOverride') || key.includes('materialOverrideColor')) {
        materialManager.handleMaterialSetting(key, value);
      }
    } else {
      // Fallback to individual handlers for backward compatibility
      switch (key) {
        // Grid settings
        case 'grid.enabled':
          gridManager.setGridVisible(value);
          break;
        case 'grid.size':
          gridManager.setGridSize(value);
          break;
        case 'grid.subsections':
          gridManager.setGridSubsections(value);
          break;

        // Brightness/Lighting settings
        case 'brightness.preset':
          lightingManager.setLightingPreset(preset);
          break;
        case 'brightness.directionalLight':
          lightingManager.setDirectionalLightEnabled(value);
          break;
        case 'brightness.directionalLightIntensity':
          lightingManager.setDirectionalLightIntensity(value);
          break;
        case 'brightness.ambientLight':
          lightingManager.setAmbientLightEnabled(value);
          break;
        case 'brightness.ambientLightIntensity':
          lightingManager.setAmbientLightIntensity(value);
          break;

        default:
          console.warn(`Unhandled viewport setting: ${key}`);
      }
    }
  };

  return {
    handleViewportSettingChange,
    // Export managers for direct access if needed
    backgroundManager,
    edgesManager,
    lightingManager,
    projectorManager,
  };
};
